import axios from "axios";
import qs from "qs";
import * as actionType from "../../../constant/actionType";

/**
 * Fetch provider insurance report rows.
 * @param {object} apiData - filters: approval_status, provider_org_ids, client_org_ids,
 *   state_ids, client_contact_name, doc_name, expiry_date_range, search, page, limit, sort, order
 * @param {string} [portalType="admin"] - "admin" | "client"
 */
export const GenerateProviderInsuranceReport = (apiData, portalType = "admin") => async () => {
  try {
    const url =
      portalType === "client"
        ? `${actionType.environment_url}/api/client/GenerateProviderInsuranceReport`
        : `${actionType.environment_url}/api/admin/provider/GenerateProviderInsuranceReport`;

    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url,
      params: apiData,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
    });

    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
};
